import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { captureError } from './services/posthog';

export const isNative = Capacitor.isNativePlatform() || window.location.protocol === 'capacitor:';
export const platform = Capacitor.getPlatform();

export async function initCapacitor() {
  if (!isNative) return;

  try {
    if (platform === 'ios') {
      await StatusBar.setStyle({ style: Style.Dark });
    }

    if (platform === 'android') {
      await StatusBar.setBackgroundColor({ color: '#0a202e' });
      await StatusBar.setStyle({ style: Style.Dark });
    }

    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });
    Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-open');
    });

    App.addListener('appUrlOpen', ({ url }) => {
      const parsed = new URL(url);
      if (parsed.protocol === 'msauth:' && parsed.hash) {
        Browser.close().catch(() => {});
        window.location.href = `/microsoft/callback${parsed.hash}`;
        return;
      }
      const path = parsed.pathname;
      if (path && path !== '/') {
        window.location.href = path;
      }
    });

    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      }
    });

    await SplashScreen.hide();
  } catch (e) {
    console.error('[initCapacitor] error:', e);
    captureError(e, { component: 'initCapacitor', platform });
  }
}
